export const EVENTS = {
  // Path: website/common/events.ts
  noteCreated: 'note-created',
  noteActivated: 'note-activated',
  noteTextSaved: 'note-text-saved',
  noteRecipientAdded: 'note-recipient-added',
}
